import { createSlice } from "@reduxjs/toolkit";
// redux
import { batch } from "src/redux/store";
// utils
import axios, { API_ENDPOINTS } from "src/utils/axios";

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    hasCheckedPlan: false,
    error: null,
    hasTrial: null,
    hasPayFailed: null,
    plan: null
};

const slice = createSlice({
    name: "plan",
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
            //
            state.hasCheckedPlan = false;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
            //
            state.hasCheckedPlan = true;
        },

        clearError(state) {
            state.error = null;
        },

        // GET PLAN
        getPlanSuccess(state, action) {
            state.isLoading = false;
            //
            state.plan = action.payload;
        },

        checkHasTriaPlanSuccess(state, action) {
            state.isLoading = false;
            //
            state.hasTrial = action.payload;
        },

        checkHasPayFailedPlanSuccess(state, action) {
            state.isLoading = false;
            //
            state.hasPayFailed = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
// export const {} = slice.actions;

// ----------------------------------------------------------------------

export function checkHasTrialPlan() {
    return async (dispatch) => {
        try {
            const response = await axios.get(API_ENDPOINTS.plan.hasTrial);

            const { status, data } = response;

            if (status === 200 && data?.code === "ok") {
                dispatch(slice.actions.checkHasTriaPlanSuccess(data?.data ?? false));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

// ----------------------------------------------------------------------

export function checkHasPayFailedPlan() {
    return async (dispatch) => {
        try {
            const response = await axios.get(API_ENDPOINTS.plan.checkHasPayFailed);

            const { status, data } = response;

            if (status === 200 && data?.code === "ok") {
                dispatch(slice.actions.checkHasPayFailedPlanSuccess(data?.data ?? false));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

// ----------------------------------------------------------------------

export function getCurrentPlan() {
    return (dispatch) => batch(async () => {
        dispatch(slice.actions.startLoading());

        try {
            const response = await axios.get(API_ENDPOINTS.plan.getDetail);

            const { status, data } = response;

            if (status === 200 && data?.code === "ok") {
                dispatch(slice.actions.getPlanSuccess(data?.data ?? []));
                //
                dispatch(checkHasTrialPlan());
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    });
}

// ----------------------------------------------------------------------

export function bindPlan(detail) {
    return async (dispatch, getState) => {
        dispatch(slice.actions.startLoading());

        try {
            const { isRewardUser } = getState().user;

            const { status } = isRewardUser ?
                await axios.post(API_ENDPOINTS.plan.bindSpecial, detail) :
                await axios.post(API_ENDPOINTS.plan.bind, detail);

            if (status === 200) {
                dispatch(getCurrentPlan());
                //
                return true;
            }
            return false;
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            //
            return false;
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}
